import { render, staticRenderFns } from "./familyManagement.vue?vue&type=template&id=ba240b30&"
import script from "./familyManagement.vue?vue&type=script&lang=js&"
export * from "./familyManagement.vue?vue&type=script&lang=js&"
import style0 from "./familyManagement.vue?vue&type=style&index=0&id=ba240b30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports